import { ButtonGroup } from "@mui/material";
import { data } from "jquery";
import { useState } from "react";
import { useRef } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import ARIMemberSearchForm from "webapp/components/Partner/ARI/ARIMemberSearchForm/ARIMemberSearchForm";
import { ContractSearchForm } from "webapp/components/Partner/LDS/ContractSearchForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function ARIMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [last8Vin, setLast8VIN] = useState(
    props.context.state.MemberLookup.Last8VIN || props.context.state.last8Vin || "",
  );

  const [licensePlate, setLicensePlate] = useState(
    props.context.state.MemberLookup.LicensePlate || props.context.state.LicensePlate || "",
  );

  const [provinceCode, setProvinceCode] = useState(
    props.context.state.MemberLookup.ProvinceCode || props.context.state.ProvinceCode || "",
  );

  const [clientId, setClientId] = useState(
    props.context.state.MemberLookup.ClientID || props.context.state.ClientID || "",
  );

  const [unitNo, setUnitNo] = useState(props.context.state.MemberLookup.UnitNo || props.context.state.UnitNo || "");

  const [odometer, setODometer] = useState(
    props.context.state.MemberLookup.Odometer || props.context.state.Odometer || "",
  );

  const [searchType, setSearchType] = useState(props.context.state.MemberLookup.SearchType || "");

  const [serviceCardNum, setServiceCardNum] = useState(
    props.context.state.MemberLookup.ServiceCardNum || props.context.state.ServiceCardNum || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };
  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.current !== "undefined") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.last8VIN === "string") {
        setLast8VIN(data.last8VIN);
      }

      if (typeof data.licensePlate === "string") {
        setLicensePlate(data.licensePlate);
      }

      if (typeof data.provinceCode === "string") {
        setProvinceCode(data.provinceCode);
      }

      if (typeof data.clientId === "string") {
        setClientId(data.clientId);
      }

      if (typeof data.unitNo === "string") {
        setUnitNo(data.unitNo);
      }

      if (typeof data.serviceCardNum === "string") {
        setServiceCardNum(data.serviceCardNum);
      }

      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
      if (typeof data.odometer === "string") {
        setODometer(data.odometer);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
        Odometer: data.odometer,
        FirstName: !!data.firstName ? data.firstName : context.state.FirstName,
        LastName: !!data.lastName ? data.lastName : context.state.LastName,
        MemberLookup: {
          VIN: data.last8VIN,
          LicensePlate: data.licensePlate,
          ProvinceCode: data.provinceCode,
          ClientID: data.clientId,
          UnitNo: data.unitNo,
          ServiceCardNum: data.serviceCardNum,
          Odometer: data.odometer,
          SearchType: data.searchType,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("ARI.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("ARI.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />

      <ARIMemberSearchForm
        currState={props.currState}
        context={props.context}
        last8Vin={last8Vin}
        licensePlate={licensePlate}
        provinceCode={provinceCode}
        clientId={clientId}
        unitNo={unitNo}
        odometer={odometer}
        serviceCardNum={serviceCardNum}
        partner={props.currState.partner}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
      />
    </div>
  );
}

export default ARIMemberSearch;
